module.exports = __webpack_public_path__ + "img/pptx.60f784d6.png";